import { gql } from '~/src/generated/portal/gql';

export const GET_API_TEST_SETS = gql(`
  query getApiTestSets($type: TestType, $sortBy: TestSetSorting, $isGoldStandard: Boolean) {
    testSets(type: $type, sortBy: $sortBy, isGoldStandard: $isGoldStandard) {
      id
      name
      description
      created
      isGoldStandard
      tests {
        __typename
        ... on APITest {
          id
          displayId
          name
          isGoldStandard
          labels {
            label
          }
        }
      }
    }
  }
`);

export const GET_API_TEST_SETS_BOUNDED = gql(`
  query getApiTestSetsBounded($type: TestType, $sortBy: TestSetSorting) {
    testSets(type: $type, sortBy: $sortBy) {
      id
      name
      description
      isGoldStandard
    }
  }
`);
